/* =========================================================
   TJD Pop-Up System — Trigger & Submission Logic
   =========================================================
   Preview any popup instantly (bypasses timers & cookies):
     ?tjd_popup=bridal-exit
     ?tjd_popup=statement-exit
     ?tjd_popup=lina-exit
     ?tjd_popup=consult-offer     ← $300 consultation credit (light world)
   ========================================================= */

(function () {
  'use strict';

  var COOKIE_POPUP = 'tjd_popup_seen';
  /* The $300 offer gets its OWN cookie, deliberately. Sharing tjd_popup_seen
     meant a generic 25s email popup on /pages/fine-jewelry could silence the
     far more valuable offer for a full week before the shopper ever reached
     /pages/engagement. The asymmetry is intentional:
       generic fired first  → offer STILL allowed (own cookie)
       offer   fired first  → generics suppressed (it writes BOTH cookies)   */
  var COOKIE_OFFER = 'tjd_offer_seen';
  var COOKIE_DAYS  = 7;
  var REDUCED      = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var popupShown   = false; // in-memory guard: at most one open per page view

  // ── Preview mode (URL param bypasses all gates) ─────────
  var params    = new URLSearchParams(window.location.search);
  var previewId = params.get('tjd_popup');
  var isPreview = !!previewId;

  // ── Cookie helpers ───────────────────────────────────────
  function setCookie(name, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 864e5);
    document.cookie = name + '=1;expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  function getCookie(name) {
    return document.cookie.split(';').some(function (c) {
      return c.trim().startsWith(name + '=');
    });
  }

  // ── Particle system ──────────────────────────────────────
  function pRand(a, b) { return Math.random() * (b - a) + a; }

  function makePopupParticle(type) {
    var base = { type: type, x: 0, y: 0, swayPhase: pRand(0, Math.PI * 2) };
    if (type === 'bokeh') {
      return Object.assign({}, base, {
        size: pRand(30, 80), speed: pRand(0.03, 0.10), opacity: pRand(0.06, 0.14),
        swayAmp: pRand(0.04, 0.14), swayFreq: pRand(0.001, 0.004),
        r: 210, g: 175, b: 80
      });
    }
    if (type === 'star') {
      return Object.assign({}, base, {
        size: pRand(2.5, 6.0), speed: pRand(0.05, 0.14), opacity: pRand(0.14, 0.45),
        swayAmp: pRand(0.08, 0.26), swayFreq: pRand(0.002, 0.007),
        glintPhase: pRand(0, Math.PI * 2), glintFreq: pRand(0.010, 0.030),
        rotation: pRand(0, Math.PI / 4), rotSpeed: pRand(-0.004, 0.004)
      });
    }
    var gold = Math.random() > 0.40;
    return Object.assign({}, base, {
      type: 'spark',
      size: pRand(0.7, 2.2), speed: pRand(0.10, 0.35), opacity: pRand(0.42, 0.88),
      swayAmp: pRand(0.12, 0.52), swayFreq: pRand(0.003, 0.011),
      glintPhase: pRand(0, Math.PI * 2), glintFreq: pRand(0.022, 0.065),
      r: gold ? 218 : 255, g: gold ? 178 : 252, b: gold ? 72 : 240
    });
  }

  function drawBokeh(ctx, p, sx) {
    var g = ctx.createRadialGradient(sx, p.y, 0, sx, p.y, p.size);
    g.addColorStop(0,    'rgba(' + p.r + ',' + p.g + ',' + p.b + ',' + p.opacity + ')');
    g.addColorStop(0.42, 'rgba(' + p.r + ',' + p.g + ',' + p.b + ',' + (p.opacity * 0.36) + ')');
    g.addColorStop(1,    'rgba(' + p.r + ',' + p.g + ',' + p.b + ',0)');
    ctx.fillStyle = g;
    ctx.beginPath();
    ctx.arc(sx, p.y, p.size, 0, Math.PI * 2);
    ctx.fill();
  }

  function drawSpark(ctx, p, sx, frame) {
    var tw = 0.5 + 0.5 * Math.sin(frame * p.glintFreq + p.glintPhase);
    var op = p.opacity * (0.36 + 0.64 * tw);
    var halo = ctx.createRadialGradient(sx, p.y, 0, sx, p.y, p.size * 6);
    halo.addColorStop(0, 'rgba(' + p.r + ',' + p.g + ',' + p.b + ',' + (op * 0.28) + ')');
    halo.addColorStop(1, 'rgba(' + p.r + ',' + p.g + ',' + p.b + ',0)');
    ctx.fillStyle = halo;
    ctx.beginPath();
    ctx.arc(sx, p.y, p.size * 6, 0, Math.PI * 2);
    ctx.fill();
    ctx.fillStyle = 'rgba(' + p.r + ',' + p.g + ',' + p.b + ',' + op + ')';
    ctx.beginPath();
    ctx.arc(sx, p.y, p.size, 0, Math.PI * 2);
    ctx.fill();
  }

  function drawStar(ctx, p, sx, frame) {
    var tw = 0.5 + 0.5 * Math.sin(frame * p.glintFreq + p.glintPhase);
    var op = p.opacity * (0.28 + 0.72 * tw);
    var sz = p.size  * (0.72 + 0.28 * tw);
    p.rotation += p.rotSpeed;
    ctx.save();
    ctx.translate(sx, p.y);
    ctx.rotate(p.rotation);
    ctx.globalAlpha = op;
    var glow = ctx.createRadialGradient(0, 0, 0, 0, 0, sz * 5);
    glow.addColorStop(0, 'rgba(255,252,228,0.65)');
    glow.addColorStop(1, 'rgba(255,252,228,0)');
    ctx.fillStyle = glow;
    ctx.beginPath();
    ctx.arc(0, 0, sz * 5, 0, Math.PI * 2);
    ctx.fill();
    ctx.fillStyle = 'rgba(255,254,244,0.98)';
    ctx.beginPath();
    for (var i = 0; i < 8; i++) {
      var angle = (i / 8) * Math.PI * 2 - Math.PI / 2;
      var r     = i % 2 === 0 ? sz : sz * 0.11;
      var px    = Math.cos(angle) * r;
      var py    = Math.sin(angle) * r;
      i === 0 ? ctx.moveTo(px, py) : ctx.lineTo(px, py);
    }
    ctx.closePath();
    ctx.fill();
    ctx.globalAlpha = op * 0.32;
    ctx.strokeStyle = 'rgba(255,248,210,1)';
    ctx.lineWidth   = 0.6;
    ctx.beginPath(); ctx.moveTo(-sz * 3, 0);   ctx.lineTo(sz * 3, 0);   ctx.stroke();
    ctx.beginPath(); ctx.moveTo(0, -sz * 1.7);  ctx.lineTo(0, sz * 1.7); ctx.stroke();
    ctx.restore();
  }

  function initPopupCanvas(canvas) {
    if (!canvas || canvas._tjdInited) return;
    canvas._tjdInited = true;
    var modal = canvas.closest('.tjd-popup-modal');
    if (!modal) return;
    var ctx    = canvas.getContext('2d');
    var rafId  = null;
    var frame  = 0;
    var particles = [];

    function buildParticles() {
      canvas.width  = modal.offsetWidth;
      canvas.height = modal.offsetHeight;
      particles = [];
      var i;
      for (i = 0; i < 5; i++) {
        var b = makePopupParticle('bokeh');
        b.x = pRand(0, canvas.width); b.y = pRand(0, canvas.height);
        particles.push(b);
      }
      for (i = 0; i < 20; i++) {
        var s = makePopupParticle('spark');
        s.x = pRand(0, canvas.width); s.y = pRand(0, canvas.height);
        particles.push(s);
      }
      for (i = 0; i < 3; i++) {
        var t = makePopupParticle('star');
        t.x = pRand(0, canvas.width); t.y = pRand(0, canvas.height);
        particles.push(t);
      }
    }

    window.addEventListener('resize', function () {
      if (rafId) buildParticles();
    }, { passive: true });

    function animate() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      frame++;
      for (var i = 0; i < particles.length; i++) {
        var p = particles[i];
        p.y -= p.speed;
        if (p.y + (p.size || 0) < 0) {
          p.y = canvas.height + (p.size || 4);
          p.x = pRand(0, canvas.width);
        }
        var sx = p.x + Math.sin(frame * p.swayFreq + p.swayPhase) * (p.swayAmp || 0) * 55;
        if (p.type === 'bokeh') drawBokeh(ctx, p, sx);
        else if (p.type === 'star') drawStar(ctx, p, sx, frame);
        else drawSpark(ctx, p, sx, frame);
      }
      rafId = requestAnimationFrame(animate);
    }

    canvas.startParticles = function () {
      buildParticles();
      if (!REDUCED && !rafId) rafId = requestAnimationFrame(animate);
    };

    canvas.stopParticles = function () {
      cancelAnimationFrame(rafId);
      rafId = null;
    };
  }

  // ── Overlay open / close ─────────────────────────────────
  function openOverlay(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.classList.add('is-active');
    var canvas = el.querySelector('.tjd-popup-canvas');
    if (canvas) setTimeout(function () { canvas.startParticles && canvas.startParticles(); }, 60);
  }

  function closeOverlay(id, setMainCookie) {
    var el = document.getElementById(id);
    if (el) {
      el.classList.remove('is-active');
      var canvas = el.querySelector('.tjd-popup-canvas');
      if (canvas) canvas.stopParticles && canvas.stopParticles();
    }
    if (setMainCookie && !isPreview) setCookie(COOKIE_POPUP, COOKIE_DAYS);
  }

  // ── Single gated trigger — every trigger routes through here ──
  // Honors the 7-day cookie AND an in-memory flag, then writes the
  // cookie the instant the popup opens so no other trigger (timer,
  // scroll, or exit-intent) can re-open it this visit or this week.
  function triggerPopup(id) {
    if (popupShown || getCookie(COOKIE_POPUP)) return;
    popupShown = true;
    setCookie(COOKIE_POPUP, COOKIE_DAYS);
    openOverlay(id);
  }

  // ── Native submit into hidden iframe → success message → auto-close ──
  function wireForm(formId, overlayId, successId) {
    var form = document.getElementById(formId);
    if (!form) return;

    /* Posts NATIVELY into the hidden iframe declared in sections/tjd-popups.liquid.
       It used to preventDefault and fetch('/contact'), which looked like an
       ordinary AJAX submit and never worked: a fetch is not a form, so Shopify's
       captcha-bootstrap can never bind it or give it a token, and every post came
       back 400 "Missing CAPTCHA token" into a .catch(){}. No pop-up on this site
       has created a customer since storefront captcha was switched on. Found and
       proven 2026-08-06 (tests/probe-*.js). Do not re-introduce the fetch.

       The submit event is NOT prevented now — that is the point. The bootstrap
       needs it to run so it can attach the token, and target="tjd-popup-customer-sink"
       keeps the page in place. The success UI is driven off the iframe's load.

       "Delivered", not "accepted": the storefront sends x-frame-options: DENY and
       frame-ancestors 'none', so the response is never rendered in the frame and
       its location cannot be read. The POST still reaches Shopify and still
       creates the customer — only the ANSWER is unreadable, so a rejection is
       indistinguishable from a success here. Do not add /challenge detection: it
       can never fire. */
    var submitted = false;

    function showSuccess() {
      form.style.display = 'none';
      var s = document.getElementById(successId);
      if (s) s.classList.add('is-visible');
      if (!isPreview) setCookie(COOKIE_POPUP, COOKIE_DAYS);
      setTimeout(function () { closeOverlay(overlayId, false); }, 2400);

      // Meta pixel — InquiryLead (CUSTOM, deliberately NOT standard `Lead`).
      // It means "submitted", which is all this surface can honestly observe.
      //
      // WHY NOT `Lead`: standard `Lead` is reserved EXCLUSIVELY for
      // /pages/book-a-consultation, which is what the paid consultation campaign
      // optimizes on. This popup captures an email with no timeline qualifier — a
      // much lower bar. Firing `Lead` here trains delivery toward people who hand
      // an address to a pop-up and inflates the campaign's CPL with conversions it
      // never caused. See handbook §12.2 and the 2026-08-06 ads-mutation-reviewer
      // findings (P1-7) in docs/ai/tasks/2026-08-05-engagement-lead-landing-page.md.
      if (typeof fbq === 'function') {
        try {
          fbq('trackCustom', 'InquiryLead', {
            content_name:     'Exit-Intent Popup',
            content_category: formId.replace('tjd-form-', '').replace('-exit', '')
          });
        } catch (e) {}
      }
    }

    form.addEventListener('submit', function () {
      var sink = document.getElementById('tjd-popup-customer-sink');
      if (!sink) {
        /* A `target` naming a browsing context that does not exist makes the
           browser open a NEW WINDOW. Drop it so the post navigates this tab
           instead — degraded, but it still creates the customer. */
        form.removeAttribute('target');
        return;
      }

      /* Nothing visible happens until the post returns, so a shopper will click
         twice. Without this lock that means two listeners, two InquiryLead
         events and the close sequence running twice. */
      if (submitted) return;
      submitted = true;

      var settled = false;
      function settle() {
        if (settled) return;
        settled = true;
        showSuccess();
      }

      function onSinkLoad() {
        // An src-less iframe fires load for its initial about:blank; that is not
        // the response and must not be mistaken for one.
        var href = '';
        try { href = sink.contentWindow.location.href || ''; } catch (err) {
          href = '(blocked-by-frame-ancestors)'; // expected — the normal path
        }
        if (!href || href === 'about:blank') return;
        sink.removeEventListener('load', onSinkLoad);
        settle();
      }
      sink.addEventListener('load', onSinkLoad);

      /* If hCaptcha demands an interactive challenge it cannot present one from
         a pop-up, no POST is ever made and no load ever fires. Without this the
         shopper stares at an unchanged form forever. Show the success state
         anyway — they gave us their address and cannot act on a Shopify-side
         rejection; the lead is what is lost, not their time. */
      setTimeout(settle, 8000);
    });
  }

  // ── Exit-intent (cursor leaves toward top of viewport) ──
  function onExitIntent(cb) {
    var fired = false;
    document.addEventListener('mouseleave', function (e) {
      if (!fired && e.clientY <= 4) { fired = true; cb(); }
    });
  }

  // ── Scroll depth trigger ─────────────────────────────────
  function onScrollDepth(pct, cb) {
    var fired = false;
    window.addEventListener('scroll', function () {
      if (fired) return;
      var scrollable = document.body.scrollHeight - window.innerHeight;
      if (scrollable <= 0) return;
      if ((window.scrollY / scrollable) * 100 >= pct) {
        fired = true;
        cb();
      }
    }, { passive: true });
  }

  // ── Page path helpers ────────────────────────────────────
  var path = window.location.pathname;

  var isBridalHub = /^\/(pages\/bridal|pages\/fine-jewelry)/.test(path);
  /* Handles are almost all `the-lina-*` (the-lina-halo-oval-cut-14k-white-gold,
     the-lina-pave-marquise, …). Exactly ONE is bare `lina-*`
     (lina-solitaire-ring-round-cut). The original /^\/products\/lina/ therefore
     armed the offer on 1 of 48 Lina PDPs and silently skipped the rest — it read
     as "the popup is broken" because on any ring you'd actually browse to, it
     was never armed at all. The optional `the-` prefix covers both. */
  var isLinaPDP   = /^\/products\/(the-)?lina[-/]/.test(path);
  var isStatement = /^\/(pages\/statement|pages\/custom-inquiry)/.test(path);
  var isEngageHub = /^\/pages\/engagement/.test(path);
  /* The Lina Ring Builder (/pages/the-lina-ring-builder). Added 2026-07-31 on
     the owner's ask: the offer should fire when someone FINISHES the builder.
     Separate flag from isEngageHub because the completion bar is different —
     the hub arms at depth >= 2, the builder waits for all three axes. */
  var isBuilder   = /^\/pages\/the-lina-ring-builder/.test(path);

  /* ── $300 CONSULTATION CREDIT (added 2026-07-31) ───────────────────────────
     Runs on the Engagement Hub and the Lina PDPs. On those two surfaces it
     REPLACES the generic exit-intent pop-up rather than competing with it:
     every pop-up on this site shares one 7-day cookie, so whichever fires first
     silences the rest for a week. The $300 offer is worth more than a generic
     email capture, so it wins outright — see `offerOwnsPage` below.

     Trigger rule: never on a timer, never on arrival. It waits for a REAL
     selection, because (a) the personalised copy ("Your Oval, pavé, in 14K
     yellow gold") is the whole reason this converts better than a generic ask,
     and (b) the hub's 17.6s average dwell is the healthiest number on the site
     and an early interruption would destroy it. */
  var OFFER_OWNS_LINA = true;                 // kill-switch: false hands Lina PDPs back to lina-exit
  var offerOwnsPage   = isEngageHub || isBuilder || (isLinaPDP && OFFER_OWNS_LINA);

  function evOffer(name, params) {
    /* fbq is injected asynchronously by Shopify's Meta channel. Calling it
       directly on a fast interaction fires into the void — same queued pattern
       the Engagement Hub uses for ShapeSelect / GridInView. */
    if (typeof window.fbq === 'function') {
      try { window.fbq('trackCustom', name, params || {}); } catch (e) {}
      return;
    }
    var tries = 0;
    var iv = setInterval(function () {
      if (typeof window.fbq === 'function') {
        clearInterval(iv);
        try { window.fbq('trackCustom', name, params || {}); } catch (e) {}
      } else if (++tries > 40) {
        clearInterval(iv);
      }
    }, 250);
  }

  function readSelection() {
    try {
      var raw = window.sessionStorage.getItem('tjd_selection');
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }

  /* Turns the stored selection into a sentence. Returns '' when there is
     nothing worth naming, so the caller keeps the generic copy. */
  function describeSelection(sel) {
    if (!sel) return '';
    /* The hub emits data-metal as the downcased LABEL — "yellow gold" /
       "white gold" (space-separated), not a slug. Keying only on 'yellow' /
       'white-gold' missed every time and produced "…in White Gold." instead of
       the intended "…in 14K yellow gold." Cover both spellings. */
    var metalWords = { 'yellow': '14K yellow gold', 'white': '14K white gold',
                       'yellow gold': '14K yellow gold', 'white gold': '14K white gold',
                       'yellow-gold': '14K yellow gold', 'white-gold': '14K white gold' };
    function pretty(v) {
      if (!v) return '';
      return String(v).replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
    }
    /* Only name the ring when we are actually ON that ring's page. The hub grid
       holds 48 rings and not all of them are Lina, so a shopper who clicked a
       different ring earlier in the session must not be told "Your <other
       ring>" on a Lina PDP. */
    if (sel.ring && sel.href && window.location.pathname.indexOf(sel.href.split('?')[0]) === 0) {
      return 'Your ' + sel.ring + ' — let’s make it exactly right, together.';
    }
    var bits = [];
    if (sel.shape) bits.push(pretty(sel.shape));
    if (sel.style) bits.push(pretty(sel.style).toLowerCase());
    if (!bits.length) return '';
    var line = 'Your ' + bits.join(', ');
    if (sel.metal) line += ', in ' + (metalWords[sel.metal] || pretty(sel.metal));
    return line + '. Let’s make it exactly right, together.';
  }

  function armConsultOffer() {
    var OVERLAY = 'tjd-popup-consult-offer';
    var el = document.getElementById(OVERLAY);
    if (!el) return;

    var armed      = false;
    var offerShown = false;

    function show(reason) {
      if (offerShown || getCookie(COOKIE_OFFER)) return;

      /* Bind the credit form to hCaptcha HERE rather than with a
         data-shopify-captcha attribute in the markup. The attribute binds at
         DOMContentLoaded, and this section is included in theme.liquid — that
         would pull hCaptcha's provider script onto EVERY page of the store for
         a form almost nobody reaches. Binding when the offer actually opens
         costs nothing elsewhere and still leaves the provider ample time: the
         shopper has to type an email and submit before the booking click that
         uses this form.

         The four capture forms above need no equivalent — the shopper types
         into them, and a focusin binds a form all by itself. */
      try {
        var cForm = document.getElementById('tjd-popup-credit-form');
        if (cForm && window.Shopify && Shopify.captcha && !cForm.dataset.cptcha) {
          Shopify.captcha.protect(cForm);
        }
      } catch (e) { /* unprotected: the post may 400, exactly as it did before */ }

      var sel  = readSelection();
      var line = describeSelection(sel);

      var subEl = document.getElementById('tjd-consult-selection');
      if (subEl) {
        subEl.textContent = line || subEl.getAttribute('data-default') || subEl.textContent;
      }

      /* Carry the selection into Shopify as customer tags — form_type=customer
         accepts tags but silently drops arbitrary custom fields. */
      var tagEl = document.getElementById('tjd-consult-tags');
      if (tagEl && sel) {
        /* Slugify — the hub emits space-separated labels ("white gold"), which
           would otherwise produce the tag "metal-white gold" and split badly in
           Shopify's segment filters. */
        function slug(v) { return String(v).trim().toLowerCase().replace(/\s+/g, '-'); }
        /* `consult-lead`, not `consult-credit-300` — the credit tag triggers the
           code email and is earned by BOOKING, not by submitting an address.
           Keep this in step with the hidden input's default in
           sections/tjd-popups.liquid; this line overwrites it. */
        var tags = ['consult-lead'];
        if (sel.shape) tags.push('shape-' + slug(sel.shape));
        if (sel.style) tags.push('style-' + slug(sel.style));
        if (sel.metal) tags.push('metal-' + slug(sel.metal));
        tagEl.value = tags.join(', ');
      }

      /* Own gate, not triggerPopup(): the offer must not be blocked by the
         shared cookie, but it DOES write it so the generic popups stay quiet
         afterwards. */
      offerShown = true;
      if (!isPreview) {
        setCookie(COOKIE_OFFER, COOKIE_DAYS);
        setCookie(COOKIE_POPUP, COOKIE_DAYS);
      }
      popupShown = true;
      openOverlay(OVERLAY);

      evOffer('ConsultOfferView', {
        content_name: 'Consultation Credit $300',
        trigger: reason,
        personalized: line ? 'yes' : 'no',
        shape: (sel && sel.shape) || '',
        depth: (sel && sel.depth) || 0
      });
    }

    /* Arm once the shopper has actually committed to something, then wait for a
       natural pause — exit intent, or a short dwell — so the offer lands as a
       next step rather than an interruption mid-browse. */
    function arm(reason) {
      if (armed) return;
      armed = true;
      onExitIntent(function () { show(reason + '+exit'); });
      setTimeout(function () { show(reason + '+dwell'); }, 12000);
    }

    if (isEngageHub) {
      document.addEventListener('tjd:selection', function (e) {
        var d = (e && e.detail) || {};
        /* A ring click is unambiguous intent — arm immediately. Filter taps
           need two axes set before they count as "a selection", so one idle
           shape tap does not trigger anything. */
        /* ring-click normally navigates away immediately (the cards are <a>),
           so this branch only matters when navigation is prevented — a
           modified click, or a blocked pop-out. The load-bearing part of a ring
           click is the sessionStorage write, which the PDP reads on arrival. */
        if (d.clicked) arm('ring-click');
        else if ((d.depth || 0) >= 2 && !d.deeplink) arm('filters');
      });
    }

    if (isBuilder) {
      /* "Finished the builder" = all three axes chosen (shape + style + metal).
         The builder emits the same `tjd:selection` payload as the hub from the
         end of its applyFilters(), so this needs no builder-specific parsing.

         depth === 3, not >= 2: on the hub, two axes is a reasonable read of
         intent because the hub is a browse surface. The builder is a COMMIT
         surface — a half-configured ring is someone mid-thought, and
         interrupting them there is worse than waiting. Hitting reset drops
         depth to 0, which re-arms this for the next completed configuration
         (the cookie still limits it to one showing per 7 days).

         No dwell or scroll fallback here on purpose. On the PDP those exist
         because a reader who never scrolls would otherwise see nothing; on the
         builder, doing nothing is a real signal that they are not ready, and
         the owner asked specifically for completion to be the trigger. */
      document.addEventListener('tjd:selection', function (e) {
        var d = (e && e.detail) || {};
        if ((d.depth || 0) < 3 || armed) return;
        armed = true;

        /* Deliberately NOT arm(). arm() waits for exit-intent or a 12s dwell,
           which is right for a browse surface where you are interrupting
           someone mid-scroll. Here the completion IS the pause — the owner
           asked for it to appear once the builder is finished, and making them
           sit through 12s after the last tap would read as unrelated to what
           they just did.

           1600ms rather than 0ms so the grid finishes re-filtering first and
           the pop-up reads as a response to completing the ring rather than a
           jump-scare over a still-updating page. Exit-intent still short-cuts
           it if they reach for the tab bar sooner. */
        onExitIntent(function () { show('builder-complete+exit'); });
        setTimeout(function () { show('builder-complete'); }, 1600);
      });
    }

    if (isLinaPDP) {
      /* They arrived on a ring page carrying a REAL selection from the hub —
         the deepest intent the funnel produces, so the offer is warranted
         without further interaction here.
         `deeplink` selections are excluded: a ?shape=oval ad link synthesises a
         filter click on load, which would otherwise score every ad visitor as
         high-intent having done nothing but click an ad. */
      var carried = readSelection();
      var realSelection = carried && !carried.deeplink &&
                          (carried.clicked || (carried.depth || 0) >= 2);
      if (realSelection) {
        arm('from-hub');
      } else {
        onScrollDepth(45, function () { arm('pdp-scroll'); });
        /* Floor, so this surface is never silent longer than the 25s timer the
           suppressed lina-exit popup used to provide. Exit-intent is
           mouseleave-based and never fires on touch, so without this a mobile
           visitor who reads without scrolling past 45% would see nothing at
           all — a straight lead-loss regression against the old behaviour. */
        setTimeout(function () { show('pdp-dwell'); }, 22000);
      }
    }

    wireForm('tjd-form-consult-offer', OVERLAY, 'tjd-success-consult-offer');

    /* Submit + booking instrumentation. wireForm already fires the custom
       InquiryLead event on a verified-OK response (NOT standard `Lead` — that
       is reserved for /pages/book-a-consultation, see the comment at the fbq
       call above); these two custom events let the Command Center read the
       offer funnel separately (viewed → submitted → booked). */
    var form = document.getElementById('tjd-form-consult-offer');
    if (form) {
      form.addEventListener('submit', function () {
        var sel = readSelection();
        evOffer('ConsultOfferSubmit', {
          content_name: 'Consultation Credit $300',
          shape: (sel && sel.shape) || '',
          ring:  (sel && sel.ring)  || ''
        });
      });
    }
    var bookBtn = document.getElementById('tjd-consult-book');
    if (bookBtn) {
      bookBtn.addEventListener('click', function () {
        evOffer('ConsultBookingClick', { content_name: 'Consultation Credit $300' });

        /* CREDIT TAG — applied HERE, on the click through to the calendar.
           Owner decision 2026-08-06. It used to be applied by hand after a
           confirmed booking, because Google Calendar cannot tell Shopify a
           booking happened. The cost of that was not the delay; it was the day
           one gets missed and a customer who was promised a code never gets it.
           Accepted trade: a click-not-book still receives the code. They still
           have to spend $1,500+ to use it, and a redeemed credit is a sale.
           This is what the "Customer tags added" Flow fires on — see
           email-templates/SETUP-consult-credit-flow.md. */
        try {
          var f = document.getElementById('tjd-form-consult-offer');
          if (!f) return;
          var emailEl = f.querySelector('input[type="email"]');
          if (!emailEl || !emailEl.value) return;

          var tagEl = document.getElementById('tjd-consult-tags');
          var tags  = (tagEl && tagEl.value ? tagEl.value.split(',') : ['consult-lead'])
                        .map(function (t) { return t.trim(); })
                        .filter(Boolean);
          if (tags.indexOf('consult-credit-300') === -1) tags.push('consult-credit-300');

          /* Posted through the dedicated hidden form in sections/tjd-popups.liquid,
             NOT a fetch. A fetch cannot be bound by Shopify's captcha-bootstrap
             and comes back 400 "Missing CAPTCHA token" — which is what this line
             did until 2026-08-06, meaning consult-credit-300 was never applied to
             anybody and the $300 code email could never have fired for anyone.
             A separate form because `f` above is display:none by now (its success
             state replaced it) and hCaptcha will not reliably bind a hidden form.

             The button opens the calendar in a NEW tab, so this page survives and
             the post has time to complete — no keepalive race. */
          var creditForm = document.getElementById('tjd-popup-credit-form');
          if (!creditForm) return;
          var ce = document.getElementById('tjd-credit-email');
          var ct = document.getElementById('tjd-credit-tags');
          if (!ce || !ct) return;
          ce.value = emailEl.value.trim();
          ct.value = tags.join(',');
          /* requestSubmit(), NOT submit(): only requestSubmit fires the submit
             event, and that event is what the captcha-bootstrap listens for.
             form.submit() skips it and posts with no token — a silent 400. */
          creditForm.requestSubmit();
        } catch (e) {}
      });
    }
  }

  // ── Init ─────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {

    // Pre-init all canvases (sizes them while modal is in DOM)
    document.querySelectorAll('.tjd-popup-canvas').forEach(function (c) {
      initPopupCanvas(c);
    });

    // ── Preview mode: open named popup after 400 ms ───────
    if (isPreview) {
      var previewTarget = 'tjd-popup-' + previewId;
      setTimeout(function () {
        openOverlay(previewTarget);
      }, 400);
    }

    // ── Global: close on overlay backdrop click ───────────
    document.querySelectorAll('.tjd-popup-overlay').forEach(function (overlay) {
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) closeOverlay(overlay.id, true);
      });
    });

    // ── Global: close / skip buttons ─────────────────────
    document.querySelectorAll('.tjd-popup-close, .tjd-popup-skip').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var overlay = btn.closest('.tjd-popup-overlay');
        if (overlay) closeOverlay(overlay.id, true);
      });
    });

    if (isPreview) return;

    // ── Pop-Up 2: Bridal/Fine — exit intent + 25s timer + 40% scroll ──
    if (isBridalHub && !getCookie(COOKIE_POPUP)) {
      onExitIntent(function () { triggerPopup('tjd-popup-bridal-exit'); });
      setTimeout(function () { triggerPopup('tjd-popup-bridal-exit'); }, 25000);
      onScrollDepth(40, function () { triggerPopup('tjd-popup-bridal-exit'); });

      wireForm('tjd-form-bridal-exit', 'tjd-popup-bridal-exit', 'tjd-success-bridal-exit');
    }

    // ── Pop-Up 3: Statement — exit intent + 25s timer + 40% scroll ──
    if (isStatement && !getCookie(COOKIE_POPUP)) {
      onExitIntent(function () { triggerPopup('tjd-popup-statement-exit'); });
      setTimeout(function () { triggerPopup('tjd-popup-statement-exit'); }, 25000);
      onScrollDepth(40, function () { triggerPopup('tjd-popup-statement-exit'); });

      wireForm('tjd-form-statement-exit', 'tjd-popup-statement-exit', 'tjd-success-statement-exit');
    }

    // ── Pop-Up 5: Lina — exit intent + 25s timer + 40% scroll ────────
    // SUPPRESSED on the Lina PDP as of 2026-07-31: the $300 consultation-credit
    // pop-up owns this surface. Flip OFFER_OWNS_LINA to false to hand the page
    // back to the generic email ask — that is the real kill-switch. (It was
    // previously written as `!offerOwnsPage`, which is unconditionally false on
    // a Lina PDP, so this branch was dead code and the claim that the form
    // stayed wired was untrue.)
    if (isLinaPDP && !OFFER_OWNS_LINA && !getCookie(COOKIE_POPUP)) {
      onExitIntent(function () { triggerPopup('tjd-popup-lina-exit'); });
      setTimeout(function () { triggerPopup('tjd-popup-lina-exit'); }, 25000);
      onScrollDepth(40, function () { triggerPopup('tjd-popup-lina-exit'); });

      wireForm('tjd-form-lina-exit', 'tjd-popup-lina-exit', 'tjd-success-lina-exit');
    }

    // ── Pop-Up 6: $300 Consultation Credit — selection-gated ─────────
    // Gated on COOKIE_OFFER, NOT the shared COOKIE_POPUP — a generic popup seen
    // earlier in the week on another page must not silence this one.
    if (offerOwnsPage && !getCookie(COOKIE_OFFER)) {
      armConsultOffer();
    }

  });

}());
